export const FETCH_MY_TEAM_LIST_START = 'FETCH_MY_TEAM_LIST_START';
export const FETCH_MY_TEAM_LIST_ERROR = 'FETCH_MY_TEAM_LIST_ERROR';
export const RECEIVE_MY_TEAM_LIST = 'RECEIVE_MY_TEAM_LIST';

export const CLEAR_MY_TEAM_LIST_STORE = 'CLEAR_MY_TEAM_LIST_STORE';

export const FETCH_TEAM_MEMBER_DETAILS_START = 'FETCH_TEAM_MEMBER_DETAILS_START';
export const RECEIVE_TEAM_MEMBER_DETAILS = 'RECEIVE_TEAM_MEMBER_DETAILS';
export const FETCH_TEAM_MEMBER_DETAILS_ERROR = 'FETCH_TEAM_MEMBER_DETAILS_ERROR';

export const CLEAR_TEAM_MEMBER_DETAILS = 'CLEAR_TEAM_MEMBER_DETAILS';
export const SET_NEUTRAL_STATE_TEAM_MEMBER_DETAILS = 'SET_NEUTRAL_STATE_TEAM_MEMBER_DETAILS';

export const FETCH_TEAM_MEMBER_ROLES_START = 'FETCH_TEAM_MEMBER_ROLES_START';
export const RECEIVE_TEAM_MEMBER_ROLES = 'RECEIVE_TEAM_MEMBER_ROLES';
export const FETCH_TEAM_MEMBER_ROLES_ERROR = 'FETCH_TEAM_MEMBER_ROLES_ERROR';

export const CLEAR_TEAM_MEMBER_ROLES = 'CLEAR_TEAM_MEMBER_ROLES';

export const SET_TEAM_MEMBER_ROLES_START = 'SET_TEAM_MEMBER_ROLES_START';
export const SET_TEAM_MEMBER_ROLES_SUCCESSFUL = 'SET_TEAM_MEMBER_ROLES_SUCCESSFUL';
export const SET_TEAM_MEMBER_ROLES_ERROR = 'SET_TEAM_MEMBER_ROLES_ERROR';

export const SAVE_TEAM_MEMBER_STATUS_START = 'SAVE_TEAM_MEMBER_STATUS_START';
export const SAVE_TEAM_MEMBER_STATUS_SUCCESSFUL = 'SAVE_TEAM_MEMBER_STATUS_SUCCESSFUL';
export const SAVE_TEAM_MEMBER_STATUS_ERROR = 'SAVE_TEAM_MEMBER_STATUS_ERROR';

export const DELETE_TEAM_MEMBER_START = 'DELETE_TEAM_MEMBER_START';
export const DELETE_TEAM_MEMBER_SUCCESSFUL = 'DELETE_TEAM_MEMBER_SUCCESSFUL';
export const DELETE_TEAM_MEMBER_ERROR = 'DELETE_TEAM_MEMBER_ERROR';

export const FETCH_TEAM_MEMBER_STATISTICS_START = 'FETCH_TEAM_MEMBER_STATISTICS_START';
export const RECEIVE_TEAM_MEMBER_STATISTICS = 'RECEIVE_TEAM_MEMBER_STATISTICS';
export const FETCH_TEAM_MEMBER_STATISTICS_ERROR = 'FETCH_TEAM_MEMBER_STATISTICS_ERROR';

export const CLEAR_TEAM_MEMBER_STATISTICS = 'CLEAR_TEAM_MEMBER_STATISTICS';



// WEBPACK FOOTER //
// ./src/store/modules/my-team/mutation-types.js